// features/drive/components/Breadcrumb/Breadcrumb.js

import React from 'react';
import { ChevronRight } from 'lucide-react';

import useDrive from '../../hooks/useDrive';

import { BreadcrumbWrapper, BreadcrumbItem, Divider } from './Breadcrumb.styles';

const Breadcrumb = () => {
  const { breadcrumbs, setBreadcrumbs, setCurrentFolder } = useDrive();

  const handleNavigate = (folder, index) => {
    setCurrentFolder(folder.id);
    setBreadcrumbs(breadcrumbs.slice(0, index + 1));
  };

  return (
    <BreadcrumbWrapper>
      {breadcrumbs.map((item, index) => (
        <React.Fragment key={item.id}>
          <BreadcrumbItem
            $active={index === breadcrumbs.length - 1}
            onClick={() => handleNavigate(item, index)}
          >
            {item.name}
          </BreadcrumbItem>

          {index < breadcrumbs.length - 1 && (
            <Divider>
              <ChevronRight size={14} />
            </Divider>
          )}
        </React.Fragment>
      ))}
    </BreadcrumbWrapper>
  );
};

export default Breadcrumb;
